import React from 'react';
import { ICartItem } from '@adac-mp/shared';
import { HintMessage, getHintContent } from '../index';

interface IErrorMessageProps {
	tip?: React.ReactNode;
	message: string;
	className?: string;
}

export const renderErrorMessage = ({ tip, message, className }: IErrorMessageProps) => (
	<HintMessage
		className={`${className}`}
		variant="error"
		hints={[
			{
				tip,
				message,
			},
		]}
	/>
);

export const renderSectionTollProductMessage = (
	cartItems: ICartItem[],
	cartLabels,
	ref?: React.ForwardedRef<HTMLDivElement>,
) =>
	cartItems.some(({ offer }) => offer.moduleTypeId === 4 || offer.moduleTypeId === 3) &&
	!cartItems.some(({ offer }) => offer.moduleTypeId === 2) && (
		<HintMessage
			ref={ref}
			hints={getHintContent(
				'warningVignette',
				[
					{
						tip: 'Achtung:',
						message:
							'Der Kauf einer Digitalen Streckenmaut ersetzt NICHT den Kauf einer (Digitalen) Vignette.',
					},
				],
				cartLabels?.hints,
			)}
		/>
	);
